module.exports = __webpack_public_path__ + "img/dundalk-fc.5a84ba7d.png";